import React from "react";

const ArrowRightIcon = ({ className = "", width = 36, height = 18, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M0 9H34M34 9L24 1M34 9L24 17"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowRightIcon; 